<template>
  <div :class="[`key${name}`, 'hold-key', classes, keyStateClass]" title="Hold key">
    <shift-model-hand
      v-if="needShiftTarget"
      ref="modelHand"
      :hand="holdHand"
      :hide-pulse="hidePulsingLetter"
    ></shift-model-hand>
    <model-hand
      v-else
      ref="modelHand"
      :hand="holdHand"
      :hide-pulse="hidePulsingLetter"
    ></model-hand>
  </div>
</template>

<script>
import { TweenMax, TimelineMax } from 'gsap';
import BaseKey from 'mixins/BaseKey';
import ModelHand from '../hands/KeyboardHand.vue';
import ShiftModelHand from '../hands/ShiftKeyboardHand.vue';
import { mapState } from 'vuex';

export default {
  name: 'HoldKey',

  components: {
    ModelHand,
    ShiftModelHand
  },

  mixins: [BaseKey],

  props: {
    holdHand: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      pulseAnimation: {},
      touchAnimation: {},
      hidePulsingLetter: true,
      enabled: false,
      handIsTransitioning: true,
      firstTimeTouch: false,
      $modelHand: null,
      $pulseKey: null
    };
  },

  computed: {
    ...mapState('application', ['device']),

    classes() {
      return {
        ...this.baseClasses,
        target:
          this.keyboardShowing && (this.needShiftTarget ? /^[A-Z]$/.test(this.expectedKey) : true),
        tablet: this.device.isMobile && !this.device.usingExternalKeyboard,
        enabled: this.holdKeyPressed,
        highlight: this.holdKeyPressed,
        homeRow: this.roofs
      };
    },

    needShiftTarget() {
      return this.targetKey.includes('shift');
    }
  },

  watch: {
    keyboardShowing(newShowing, oldShowing) {
      if (newShowing && !oldShowing) {
        this.transitionHandOverKeyboard();
      }
    },

    holdKeyPressed(newPressed, oldPressed) {
      if (newPressed && !oldPressed) {
        this.stopPulsingLetter();
        if (this.handIsTransitioning) {
          this.positionIndexFinger();
        }
      } else if (!newPressed && oldPressed) {
        this.animatePulsingLetter();
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      const { modelHand } = this.$refs;
      this.$modelHand = modelHand.$el;
      this.$pulseKey = modelHand.$refs.pulse;
    });
  },

  methods: {
    transitionHandOverKeyboard() {
      const topPos = this.needShiftTarget ? -70 : 10;
      this.touchAnimation = new TimelineMax();

      this.touchAnimation.to(this.$modelHand, 2, { top: topPos }).call(() => {
        this.enabled = true;
        this.handIsTransitioning = false;
        this.animatePulsingLetter();
      });
    },

    positionIndexFinger() {
      this.touchAnimation = new TimelineMax();
      const progress = this.touchAnimation.progress();
      const topPos = this.needShiftTarget ? -70 : 10;
      this.firstTimeTouch = true;

      if (Number.isNaN(progress) || progress < 1) {
        this.touchAnimation.stop();
        TweenMax.set(this.$modelHand, { top: topPos });
      }

      this.handIsTransitioning = false;
    },

    animatePulsingLetter() {
      this.pulseAnimation = new TimelineMax({ delay: 3, repeat: -1 });
      if (this.pulseAnimation.restart) {
        this.pulseAnimation.restart(true);
        this.firstTimeTouch = false;
      } else {
        this.pulseAnimation
          .add(() => {
            this.hidePulsingLetter = false;
          })
          .to(this.$pulseKey, 1, { scale: 2 })
          .to(this.$pulseKey, 1, { scale: 1 });
      }

      if (this.firstTimeTouch) {
        this.pulseAnimation.stop();
      }
    },

    stopPulsingLetter() {
      if (this.pulseAnimation && this.pulseAnimation.stop) {
        this.pulseAnimation.stop();
      }

      this.hidePulsingLetter = true;
    }
  }
};
</script>
